export interface SubmissionConfirmationProps {
  /** ISO 8601. */
  submittedAt: string
  /** Set right after the respondent submits, which is what makes this the confirmation. */
  submittedByName?: string
}

function formatSubmittedAt(iso: string): string {
  return new Date(iso).toLocaleString(undefined, { dateStyle: 'long', timeStyle: 'short' })
}

/** The in-app confirmation right after submitting, and the submitted state on later visits. */
export function SubmissionConfirmation({
  submittedAt,
  submittedByName,
}: SubmissionConfirmationProps) {
  const justSubmitted = submittedByName !== undefined
  return (
    <div
      role="status"
      className="mb-8 rounded-lg border border-success bg-success-bg p-5 text-[15px] text-body"
    >
      <p className="font-semibold text-heading">
        {justSubmitted ? 'Your assessment has been submitted.' : 'This assessment was submitted.'}
      </p>
      <p className="mt-1">
        Submitted {formatSubmittedAt(submittedAt)}
        {submittedByName ? ` by ${submittedByName}` : ''}. It can no longer be edited.
      </p>
    </div>
  )
}
